var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"master"},[_c('TopBar',{attrs:{"back":"/profil","title":"Récompenses"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('p',[_vm._v("Gagnez des cartons en faisant grandir votre palette !")])])
}]

export { render, staticRenderFns }